export default "__VITE_ASSET__3781a507__"